const styles = (theme) => ({
  sortControls: {
    display: "flex",
    alignItems: "center",
  },
  sortControlsTypography: {
    marginRight: theme.spacing(),
  },
  sortControlsButton: {
    "&:last-of-type": {
      marginRight: 0,
    },
    "&:hover": {
      backgroundColor: ["transparent", "!important"],
    },
  },
  arrowIcon: {
    transition: theme.transitions.create(["transform"], {
      duration: theme.transitions.duration.complex,
    }),
  },
  text: {
    display: "flex",
    alignItems: "center",
    marginBottom: 1,
  },
  arrowIconAsc: {
    transform: "rotate(180deg)",
  },
})

export default styles
